<template>
  <div :id="uuid" :style="{ width: width + 'px', height: height + 'px' }" />
</template>

<script setup>
import { getDataJson, pollingRefresh, hasNonEmptyValues, hasProperty } from "@/utils/refresh-cpt-data";
import { onMounted, watch, computed } from "vue";
import * as echarts from 'echarts'

const props = defineProps({
  width: Number,
  height: Number,
  option: Object,
  show: Boolean,
  components: Array,
  current: Object
})
// 新增属性兼容旧代码
const attr = props.option.attribute
if (!attr.globalDataReload) attr.globalDataReload = [0]

let dataReload = computed(() => props.option.attribute.globalDataReload || [0])
watch(() => props.current.cptShow,(val)=>{
    if (val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  watch(() => props.option.attribute.hideCompInTabw,(val)=>{
    if (!val && dataReload.value.includes(1)) {
      refreshCptData();
    }
  })
  
watch(() => props.option.attribute, (obj) => {
  if (obj.dataZoom && obj.dataZoom.show) {
    obj.grid.y2 = obj.grid.y2 == 30 ? 50 : obj.grid.y2;
  } else {
    obj.grid.y2 = obj.grid.y2 == 50 && obj.grid.y2 != 30 ? 30 : obj.grid.y2;
  }
  processData(props.option.cptDataForm, newData, jsFunFlag)
  loadChart(obj);
}, { deep: true })
watch(() => [props.width, props.height], () => {
  chart.resize()
})


let uuid = require('uuid').v1();
let chartOption = {};
let chart = null
let cptData = [];
let newData = "";
let jsFunFlag = false;
const emit = defineEmits(['clickHandler'])

onMounted(() => {
  chart = echarts.init(document.getElementById(uuid))
  if (dataReload.value.includes(0)) {
    refreshCptData();
  }
})

function refreshCptData(cptDataForm = props.option.cptDataForm, paras) {
  pollingRefresh(uuid, cptDataForm, () => loadData(cptDataForm, paras),
    props.components)
}
function loadData(cptDataForm, paras) {
  getDataJson(cptDataForm, paras, (res) => {
    console.log(res, 'res**')
    // cptData = res;
    newData = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.resStr : res;//相同数据集只调用一次接口原因
    jsFunFlag = cptDataForm.dataSource == '4' && hasProperty(res, 'jsFunction') ? res.jsFunction : false;//相同数据集只调用一次接口原因
    processData(cptDataForm, newData, jsFunFlag)
    loadChart(props.option.attribute);

  })
}
function processData(cptDataForm, res, jsFunFlag) {
  // 第一层判断 如果选择数据集
  if (cptDataForm.dataSource == '4') {
    // 第二层判断 ，如果没有配转换脚本
    if (jsFunFlag) { // 没有全部配置映射字段
      if (hasNonEmptyValues(props.option.attribute.cptTableData)) {
        const dataKey = props.option.attribute.cptTableData;
        console.log(dataKey, 'dataKey')
        const hasType = dataKey && dataKey.some(ele => ele.namekey === 'type')
        console.log(hasType, 'hasType')
        if (hasType) {
          let groupedData = res.reduce((accumulator, current) => {
            let groupKey = dataKey.find(d => d.namekey === 'group').value;
            let typeKey = dataKey.find(d => d.namekey === 'type').value;
            let nameKey = dataKey.find(d => d.namekey === 'name').value;
            let valueKey = dataKey.find(d => d.namekey === 'value').value;

            let groupName = current[groupKey];
            let dataType = current[typeKey];
            let dataName = current[nameKey];
            let values = current[valueKey];

            if (!accumulator[groupName]) {
              accumulator[groupName] = { group: groupName, type: dataType, data: [] };
            }

            accumulator[groupName].data.push({ name: dataName, value: values });

            return accumulator;
          }, {});

          let newarr = Object.values(groupedData);
          cptData = newarr;
          console.log(newarr, '新数组');
        } else {
          let groupData = {};
          res && res.forEach(item => {
            let group = item[dataKey[0].value];
            let name = item[dataKey[1].value];
            let value = item[dataKey[2].value];

            if (!groupData[group]) {
              groupData[group] = { group, data: [] };
            }
            groupData[group].data.push({ name, value });
          });

          // 将 groupData 转换为 newarr 数组形式
          let newarr = Object.values(groupData).map(groupItem => ({
            ...groupItem,
          }));
          console.log(newarr, '新数组')
          cptData = newarr;
        }
      }
    } else { // 如果配置了转换脚本
      cptData = res;
    }
  } else { // 不是数据集类型，是静态数据
    cptData = res;

  }
}
function parseSLValues(slString) {
  return parseInt(slString, 10);
}


function loadChart(attribute) {

  let attr = JSON.parse(JSON.stringify(attribute))//watch循环修复，xAxis指向的对象被更改影响
  console.log(attribute, 'attributeattribute')
  let axisData = [];
  console.log(cptData, 'cptData')
  if (cptData[0]) {
    cptData[0].data.forEach(item => {
      axisData.push(item.name)
    })
  }

  chartOption = {
    color: attr.color,//配色方案
    title: attr.title,
    tooltip: attr.tooltip,
    grid: attr.grid,
    xAxis: attr.xAxis,
    yAxis: attr.yAxis,
    legend: attr.legend,
    dataZoom: attr.dataZoom,
  };

  let xAxisType = 'category';
  let yAxisType = 'value';
  if (attr.direction === 'y') {
    xAxisType = 'value';
    yAxisType = 'category';
  }
  if (chartOption.xAxis) chartOption.xAxis.type = xAxisType
  if (chartOption.yAxis) chartOption.yAxis.type = yAxisType
  if (chartOption.xAxis) chartOption.xAxis.data = axisData
  if (chartOption.yAxis) chartOption.yAxis.data = axisData
  chartOption.series = [];
  let seriesLabel = attr.series.label
  seriesLabel.formatter = '{c}' + (attr.series.label.unit || '')
  for (let i = 0; i < cptData.length; i++) {
    const item = cptData[i];
    let data = []
    item.data.forEach(column => {
      data[axisData.indexOf(column.name)] = column.value
    })
    chartOption.series.push({
      name: item.group,
      data: data,
      type: item.type ? item.type : attr.series.barType,//pictorialBar || bar
      showBackground: attr.series.showBackground,
      barGap: attr.series?.barGap || 0.4,
      smooth: attr.series.smooth,//平滑曲线
      symbol: attr.series.barType === 'pictorialBar' ? attr.series.symbol : null,
      symbolSize: item.type === 'line' ? 10 : null,
      backgroundStyle: {
        color: 'rgba(180, 180, 180, 0.2)'
      },
      barWidth: attr.series.barWidth,
      itemStyle: {
        borderRadius: attr.series.borderRadius,

      },
      label: seriesLabel,
    })
  }
  console.log(chart,'chart');
  if(!chart) {
    return 
  }
  chart.setOption(chartOption, true);
  chart.on('click', (params) => {
    emit("clickHandler", props.option.interaction, 'default', params.name, 'cpt-chart-column')
  })
}

defineExpose({ refreshCptData })
</script>

<style scoped></style>
